<template>
    <div class="c-m-search-profile">
        <h3 class="c-m-search-profile__heading">Valda kategorier</h3>
        <ul class="c-m-search-profile__list c-m-search-profile__list--head">
            <li
                v-for="cat in metaCategories"
                class="c-m-search-profile__item"
                :key="`user-${user.Id}-search-profile-cat-${cat.Id}`"
            >
                <input
                    class="c-m-search-profile__input"
                    type="checkbox"
                    :name="`search-profile-input-${cat.Id}`"
                    :id="`search-profile-input-${cat.Id}`"
                    :checked="isSelectedAll(cat)"
                    :disabled="disableEverything"
                    @change="select($event, cat)"
                />
                <label
                    class="c-m-search-profile__label"
                    :for="`search-profile-input-${cat.Id}`"
                >
                    <span class="c-m-search-profile__checkbox">
                        <icon :icon="'check'" />
                    </span>
                    <icon :icon="getIconName(cat.Name)"></icon>
                    <span class="c-m-search-profile__text">{{ cat.Name }}</span>
                </label>
                <span
                    v-if="selectedSubsCount(cat) > 0"
                    class="c-m-search-profile__count"
                >
                    <icon icon="check_circle"></icon>
                    {{ selectedSubsCount(cat) }}
                </span>
                <button
                    v-if="cat.Subcategories.length > 0"
                    class="c-m-search-profile__toggle"
                    :class="{
                        'c-m-search-profile__toggle--toggled': isActive(cat.Id)
                    }"
                    @click="toggleActive(cat.Id)"
                    aria-label="Expandera"
                >
                    <icon :icon="'expand_more'"></icon>
                </button>
                <ul
                    v-if="cat.Subcategories.length > 0 && isActive(cat.Id)"
                    class="c-m-search-profile__list c-m-search-profile__list--sub"
                >
                    <li
                        v-for="sub in cat.Subcategories"
                        class="c-m-search-profile__item"
                        :key="
                            `user-${user.Id}-search-profile-sub-cat-${sub.Id}`
                        "
                    >
                        <input
                            class="c-m-search-profile__input"
                            type="checkbox"
                            :name="`search-profile-input-sub-${sub.Id}`"
                            :id="`search-profile-input-sub-${sub.Id}`"
                            :checked="isSelected(sub.Id)"
                            :disabled="disableEverything"
                            @change="select($event, sub)"
                        />
                        <label
                            class="c-m-search-profile__label"
                            :for="`search-profile-input-sub-${sub.Id}`"
                        >
                            <span class="c-m-search-profile__checkbox">
                                <icon :icon="'check'" />
                            </span>
                            <span class="c-m-search-profile__text">{{
                                sub.Name
                            }}</span>
                        </label>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
import Icon from "../atoms/AtomIcon.vue";

export default {
    components: {
        Icon
    },
    data() {
        return {
            activeId: null
        };
    },
    props: {
        disableEverything: {
            type: Boolean,
            default: false
        },
        metaCategories: {
            type: Object,
            default: () => ({})
        },
        categories: {
            type: Array,
            default: () => []
        },
        company: {
            type: Object
        },
        user: {
            type: Object
        }
    },
    methods: {
        isActive(id) {
            return this.activeId === id;
        },
        toggleActive(id) {
            if (this.isActive(id)) {
                this.activeId = null;
            } else {
                this.activeId = id;
            }
        },
        select(event, cat) {
            const action = event.target.checked ? "add" : "delete";
            let payload = [];
            if (cat.Subcategories) {
                payload = [...cat.Subcategories];
            } else {
                payload = [cat];
            }
            this.$emit("updated", { payload, action });
        },
        isSelected(id) {
            if (this.categories.find(cat => cat.Id === id)) {
                return true;
            } else {
                return false;
            }
        },
        isSelectedAll(cat) {
            return this.selectedSubsCount(cat) === cat.Subcategories.length;
        },
        selectedSubsCount(cat) {
            const filtered = cat.Subcategories.filter(sub =>
                this.isSelected(sub.Id)
            );
            return filtered.length;
        },
        getIconName(category) {
            if (category.match(/(INSIDA)/gi)) {
                return "bed";
            } else if (category.match(/(UTSIDA)/gi)) {
                return "home";
            } else if (category.match(/(BYGGPROJEKT)/gi)) {
                return "business";
            } else if (category.match(/(ARKITEKT)/gi)) {
                return "pencil_ruler";
            } else if (category.match(/(EL, VVS)/gi)) {
                return "flash_on";
            } else if (category.match(/(TRÄDGÅRD)/gi)) {
                return "nature_people";
            } else if (category.match(/(SERVICE)/gi)) {
                return "dolly";
            } else {
                return "hammer_and_wrench";
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeSearchProfileCategories.vue